import { ValueTypeImpl } from '../FormFriendContactItem';

export const config: ValueTypeImpl[] = [
  // "email",
  // "twitter",
  // "instagram",
  // "facebook",
  // "pinterest",
];
